import * as Immutable from 'immutable';
import {createAction} from 'redux-actions';
import {createSelector} from 'reselect';
import {handleActions} from '../../Utility/HandleActions';

//action types
const SAGA_LOAD_DATA_START = "DBM/DATA/DASHBOARD/SAGA_LOAD_DATA_START";
const SAGA_LOAD_DATA_SUCCESS = "DBM/DATA/DASHBOARD/SAGA_LOAD_DATA_SUCCESS";

const sagaLoadDataStart = createAction(SAGA_LOAD_DATA_START);
const sagaLoadDataSuccess = createAction(SAGA_LOAD_DATA_SUCCESS);

export const actionTypes = {
    SAGA_LOAD_DATA_START,
    SAGA_LOAD_DATA_SUCCESS
};

export const actions = {
    sagaLoadDataStart,
    sagaLoadDataSuccess
};

export const reducer = handleActions({
    [SAGA_LOAD_DATA_START]: () => {
        return (state) => {
            return state.setIn(['data', 'dashboard'], Immutable.fromJS({}));
        }
    },
    [SAGA_LOAD_DATA_SUCCESS]: (data) => {
        return (state) => {
            if (data && Array.isArray(data.widgets)) {
                const dashboardData = {
                    ...data,
                    gridName: 'homepage_grid'
                };
                return state.setIn(['data', 'dashboard'], Immutable.fromJS(dashboardData));
            }
            return state.setIn(['data', 'dashboard'], Immutable.fromJS(data));
        }
    },
    SET_LAST_ROUTE_DATA: (data) => {
  return (state) => {
    return state.set('lastRouteData', Immutable.fromJS(data));
  };
}
});

const gridName = (state) => state.getIn(['data', 'dashboard', 'gridName']);

const gridDataImmutable = (state) => state.getIn(['data', 'dashboard']);

const widgetsByContainerIdFactory = () =>
  createSelector(
    gridDataImmutable,
    (state, containerId) => containerId,
    (gridDataImmutable, containerId) => {
      if (!gridDataImmutable) return [];
 
      let widgets;
 
      if (gridDataImmutable.get) {
        widgets = gridDataImmutable.getIn(['containers', containerId]);
      } else {
        widgets = gridDataImmutable?.containers?.[containerId];
      }
 
      if (!widgets) return [];

      // The component expects `chartData` to be an array, but the API provides { intraday: [...] }
      return widgets.map(widget =>
        widget.has('chartData') ? widget.set('chartData', widget.getIn(['chartData', 'intraday'])) : widget
      );
    }
  );
  
const lastUpdate = (state) => state.getIn(['data', 'dashboard', 'lastUpdate']);

const getWidgets = createSelector(
    gridDataImmutable,
    (gridData) => gridData ? gridData.get('widgets') : null
);



export const selectors = {
    gridName,
    widgetsByContainerIdFactory,
    lastUpdate,
    getWidgets,
    getDashboardData: gridDataImmutable,
    getLastRouteData: (state) => state.getIn(['data', 'dashboard', 'lastRouteData'])
};